import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function TagsIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="TagsIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <path
                id="FontAwsome_tags_"
                d="M16.159,7.332,9.283.456A1.558,1.558,0,0,0,8.182,0H1.558A1.558,1.558,0,0,0,0,1.558V8.182a1.558,1.558,0,0,0,.456,1.1l6.876,6.876a1.558,1.558,0,0,0,2.2,0l6.624-6.624A1.558,1.558,0,0,0,16.159,7.332ZM3.635,5.192A1.558,1.558,0,1,1,5.192,3.635,1.558,1.558,0,0,1,3.635,5.192ZM20.313,9.535l-6.624,6.624a1.558,1.558,0,0,1-2.2,0l-.012-.012L17.123,10.5a2.921,2.921,0,0,0,0-4.13L10.754,0h1.581a1.558,1.558,0,0,1,1.1.456l6.876,6.876A1.558,1.558,0,0,1,20.313,9.535Z"
                fill="none"
                stroke="#e6ba0d"
                strokeWidth="1"
            />
        </SvgIcon>
    );
}
